import React from "react";
import PostJob from "../components/PostJob/PostJob";
const PostJobPage = () => {
  return (
    <div>
      <PostJob />
    </div>
  );
};

export default PostJobPage;
